"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmployeeCardData = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const error_handler_1 = require("@app/util/error-handler");
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const useEmployeeCardData = ({ actionName, requestor, mutator, reducer, selector, listenDeps, }) => {
    const firstLoad = react_1.default.useRef(true);
    const dispatch = (0, store_1.useRootDispatch)();
    const data = (0, store_1.useRootSelector)(selector);
    const requestAction = async () => {
        await dispatch((0, ac_1.isLoading)(actionName, false));
        try {
            const data = await requestor();
            if (!(0, error_handler_1.isError)(data)) {
                return data;
            }
            console.error(data.error);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            await dispatch((0, ac_1.isLoading)(actionName, true));
        }
    };
    const mutateAction = async (inputData) => {
        if ((0, util_1.isUndefined)(mutator)) {
            throw new Error('Cannot call mutation when mutator is not defined');
        }
        await dispatch((0, ac_1.isLoading)(actionName, false));
        try {
            // @ts-expect-error
            const data = await mutator(inputData);
            if (!(0, error_handler_1.isError)(data)) {
                react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, { type: ui_1.Alert.TYPES.SUCCESS, text: (0, util_1.t)('SUCCESS_MESSAGE.employeeProfile') }));
                return data;
            }
            react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, { type: "ERROR", text: (0, util_1.t)('ERR_MESSAGE.error') }));
        }
        catch (err) {
            react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, { type: "ERROR", text: (0, util_1.t)('ERR_MESSAGE.error') }));
            console.error(err);
        }
        finally {
            await dispatch((0, ac_1.isLoading)(actionName, true));
        }
    };
    react_1.default.useEffect(() => {
        const action = async () => {
            if (firstLoad.current && (0, util_1.isDefined)(data)) {
                return;
            }
            const _data = await requestAction();
            if ((0, util_1.isUndefined)(_data)) {
                throw new Error('Data is undefined');
            }
            reducer(_data);
        };
        action().then(() => {
            firstLoad.current = false;
        }).catch(() => {
            firstLoad.current = false;
        });
    }, listenDeps);
    const reload = react_1.default.useCallback(async () => {
        const data = await requestAction();
        reducer(data);
    }, [actionName, requestor, reducer]);
    const mutate = react_1.default.useCallback(async (inputData) => {
        const data = await mutateAction(inputData);
        reducer(data);
    }, [actionName, mutator, reducer]);
    // @ts-expect-error
    return { reload, data, mutate };
};
exports.useEmployeeCardData = useEmployeeCardData;
